<template>
  <div class="ReportEntityDetails__Component">
    <FieldInlineDateTime label="תאריך התחלה" :readOnly="true" v-model="model.StartDate" />
    <FieldInlineDateTime label="תאריך סיום" :readOnly="true" v-model="model.EndDate" />
  </div>
</template>

<script>
import FieldInlineDateTime from '@/components/Fields/FieldInlineDateTime.vue';
import { mapState } from 'vuex';

export default {
  name: 'VirtualContractEntityDetails',
  components: {
    FieldInlineDateTime,
  },
  props: ['readOnly'],
  data() {
    return {
      model: {
        StartDate: null,
        EndDate: null,
      },
    };
  },
  computed: {
    ...mapState('virtualContract', ['StartDate', 'EndDate']),
  },
  created() {
    this.model = { StartDate: this.StartDate, EndDate: this.EndDate };
  },
  watch: {
    StartDate(v) { this.model.StartDate = v; },
    EndDate(v) { this.model.EndDate = v; },
  },
};
</script>

<style>
</style>
